<div class="container flex flex-column justify-content-center align-items-center">
  <div class="lock"></div>
  <div class="message flex flex-column justify-content-center align-items-center text-center">
    <h1>This page requires special permissions.<br>
      Please contact your administrator for access.</h1>
    <p>We're sorry, you don't currently have access to this page. Please check with the site admin if you believe this is a mistake.</p>
  </div>
</div>
